import { put, select, takeLatest, all, delay, call } from "redux-saga/effects";
import { GET_ALL_CASES, GET_CLOSED_CASES } from "../../actions/cases/allCasesActions";
import { GET_TYPE_ARR, GET_SPECIFIC_TYPE_ARR, CREATE_NEW_CASE } from "../../actions/cases/createCaseActions";
import { GET_ALL_VIEW_CASE_DETAILS, ADD_COMMENT, GET_ACTIVITY, CLOSE_CASE } from "../../actions/cases/viewCaseDetailsActions";
import {
  getCaseListCall,
  getClosedCaseListCall,
  getCaseStatusCall,
  getCaseTypeCall,
  getCaseSpecificTypeCall,
  createCaseCall,
  getCaseDetailsCall,
  addCommentCall,
  getActivityCall,
  closeCaseCall,
} from "../../../api/cases/index";
import * as Actions from "../../actions/cases/allCasesActions";
import * as CreateCaseActions from "../../actions/cases/createCaseActions";
import * as viewCaseDetailsActions from "../../actions/cases/viewCaseDetailsActions";
import * as GlobalActions from "../../actions/global/global";
import { pendoTrack } from "../../../util/pendoUtil";
import { constructCaseHyperLink } from "../../../util/helpURLNavigation";

const caseStatusMapping = (data) => {
  let result = data.map((item) => {
    let status = item.status ? item.status : item.value;
    switch (status) {
      case "New":
      case "Troubleshooting":
      case "Scheduled":
      case "Rescheduled":
      case "Closed":
        break;
      case "Awaiting":
        status = "Assigned";
        break;
      case "Completed":
        status = "Closed";
        break;
      case "Pending Follow-Up":
        status = "Awaiting your reply";
        break;
      case "Returned":
      case "Queued":
      default:
        status = "Troubleshooting";
        break;
    }
    if (item.hasOwnProperty("status")) {
      item.status = status;
    } else {
      item.value = status;
    }
    return item;
  });
  return result;
};

function* getAllCases() {
  let accountData = yield select((state) => state.ACCOUNT);
  try {
    yield put(Actions.setLoader(true));
    const accountstate = yield select((state) => state.ACCOUNT);
    const requestBody = {
      accountNo: accountstate.accountNumber,
      regionId: accountstate.regionId,
    };
    const response = yield getCaseListCall(requestBody);
    yield put(Actions.setIsError(false));

    if (response.data.data.data.length > 0) {
      let data = yield call(caseStatusMapping, response.data.data.data);
      data = filterCasesByPermissions(data, accountstate);
      yield put(Actions.setAllCases(data));
      yield put(Actions.setDateFormat(response.data.data.dateFormat));
      const caseListState = yield select((state) => state.CASELIST);
      if (!caseListState.statusValues.length) {
        const statusResponse = yield getCaseStatusCall();
        if (statusResponse.data.data.length > 0) {
          let statusValues = [...new Set((yield call(caseStatusMapping, statusResponse.data.data)).map((statusData) => statusData.value))];
          statusValues = [{ label: "All", value: "All" }, ...statusValues.map((statusData) => ({ label: statusData, value: statusData }))];
          if (!accountstate.technicianAppointmentValidAccess) {
            statusValues = statusValues.filter((status) => status.value !== "Rescheduled");
          }
          yield put(Actions.setCaseStatus(statusValues));
        }
      }
    } else {
      yield put(Actions.reset());
    }
    yield put(Actions.setLoader(false));
  } catch (error) {
    yield handleError(error, accountData);
  }
}

const filterCasesByPermissions = (data, accountstate) => {
  if (!(accountstate.viewFinancialCasesPermission && accountstate.viewallotherCasesPermission)) {
    if (accountstate.viewFinancialCasesPermission) {
      data = data.filter((type) => type.issueType === "Finance / Contractual");
    }
    if (accountstate.viewallotherCasesPermission) {
      data = data.filter((type) => type.issueType !== "Finance / Contractual");
    }
  }
  return data;
};

function* handleError(error, accountData) {
  console.log("getAllCases error-> ", error);
  yield put(Actions.setLoader(false));
  yield put(Actions.reset());
  yield put(Actions.setIsError(true));
  pendoTrack("Customer Portal | Support Cases | Failed To Load ", {
    status: "Unable to load data for support cases",
    statusCode: error.response.data.statusCode,
    accountId: accountData.accountNumber,
  });
}

function* getClosedCases({ callBack }) {
  try {
    yield put(Actions.setLoader(true));
    let accountstate = yield select((state) => state.ACCOUNT);
    let requestBody = {
      accountNo: accountstate.accountNumber,
      regionId: accountstate.regionId,
    };
    const response = yield getClosedCaseListCall(requestBody);
    if (response.data.data.length > 0) {
      let data = yield call(caseStatusMapping, response.data.data);
      yield put(Actions.setClosedCases(data));
      callBack(data);
    } else {
      callBack([]);
    }
    yield put(Actions.setLoader(false));
  } catch (error) {
    console.log("getClosedCases error-> ", error);
    callBack([]);
    yield put(Actions.setLoader(false));
  }
}

function* getTypeData() {
  let accountStateData = yield select((state) => state.ACCOUNT);
  try {
    yield put(Actions.setLoader(true));
    let requestBody = {
      userType: accountStateData.userType,
      regionId: accountStateData.regionId,
    };
    let response = yield getCaseTypeCall(requestBody);
    if (response.data.data.length > 0) {
      let accountstate = yield select((state) => state.ACCOUNT);
      let typeResponse = response.data.data.map((typeData) => typeData?.label);
      if (!(accountstate.viewFinancialCasesPermission && accountstate.viewallotherCasesPermission)) {
        if (accountstate.viewallotherCasesPermission) {
          typeResponse = response.data.data.filter((type) => type.label !== "Finance / Contractual").map((typeData) => typeData?.label);
        }
      }
      yield put(CreateCaseActions.setTypeArr(typeResponse));
      yield put(CreateCaseActions.setTryAgain(false));
      yield put(Actions.setLoader(false));
      yield put(Actions.toggleCreateCase(true));
      pendoTrack("Customer Portal | Support Cases | Create New Case | Case Reason Call", {
        status: "Success",
        statusCode: response.data.statusCode,
        accountId: accountstate.accountNumber,
      });
    } else {
      yield put(CreateCaseActions.setTypeArr([]));
      yield put(CreateCaseActions.setTryAgain(true));
      yield put(Actions.setLoader(false));
      yield put(Actions.toggleCreateCase(false));
      pendoTrack("Customer Portal | Support Cases | Create New Case | Case Reason Call", {
        status: "Failed",
        statusCode: response.data.statusCode,
        accountId: accountStateData.accountNumber,
      });
    }
  } catch (error) {
    console.log("getTypeData error-> ", error);
    yield put(CreateCaseActions.setTryAgain(true));
    yield put(Actions.setLoader(false));
    yield put(Actions.toggleCreateCase(false));
    pendoTrack("Customer Portal | Support Cases | Create New Case | Case Reason Call", {
      status: "Failed",
      statusCode: error.response.data.statusCode,
      accountId: accountStateData.accountNumber,
    });
  }
}

function* getSpecificTypeData() {
  try {
    let billingState = yield select((state) => state.BILLING);
    yield put(CreateCaseActions.setCancelDisable(true));
    yield put(CreateCaseActions.setLoader(true));
    let createCaseState = yield select((state) => state.CREATECASE);
    if (createCaseState.type === "Finance / Contractual" && !createCaseState.contractAccounts.length) {
      if (billingState.contractAccount) {
        yield put(CreateCaseActions.setCreateCaseFields("contractAcc", billingState.contractAccount));
      }
    }
    let requestBody = {
      label: createCaseState.type,
    };
    let response = yield getCaseSpecificTypeCall(requestBody);
    if (response.data.data.length > 0) {
      let specificTypeResponse = response.data.data.filter((specificTypeData) => specificTypeData?.label && specificTypeData.label !== "Other");
      yield put(CreateCaseActions.setSpecificTypeArr(specificTypeResponse));
    } else {
      yield put(CreateCaseActions.setSpecificTypeArr([]));
    }
    yield put(CreateCaseActions.setCancelDisable(false));
    yield put(CreateCaseActions.setLoader(false));
  } catch (error) {
    console.log("getSpecificTypeData error -> ", error);
    yield put(CreateCaseActions.setSpecificTypeArr([]));
    yield put(CreateCaseActions.setCancelDisable(false));
    yield put(CreateCaseActions.setLoader(false));
  }
}

function* createNewCase() {
  let accountStateData = yield select((state) => state.ACCOUNT);
  try {
    yield put(CreateCaseActions.setSubmitButton(true));
    yield put(CreateCaseActions.setCancelDisable(true));
    yield put(CreateCaseActions.setLoader(true));
    let createCaseState = yield select((state) => state.CREATECASE);
    let accountstate = yield select((state) => state.ACCOUNT);
    let regionId = accountstate.accountUserTokenDetails.accountRegionId;
    let requestBody = {
      accountId: accountstate.account_id,
    };
    let optionalDetails = "";
    if (createCaseState.type === "Hardware") {
      optionalDetails = ` ${createCaseState.vin}`;
    } else if (createCaseState.type === "Finance / Contractual") {
      optionalDetails = ` ${createCaseState.contractAcc} ${createCaseState.invoiceNo}`;
    }
    let initialInquiry = createCaseState.details + `${optionalDetails}`;
    requestBody = {
      lastName: createCaseState.lastName.trim(),
      firstName: createCaseState.firstName.trim(),
      emailId: accountstate.emailAddress,
      accountId: accountstate.account_id,
      subject: createCaseState.subject,
      initialInquiry: initialInquiry.trim(),
      reason: createCaseState.type,
      specificReason: createCaseState.specificType,
      origin: "VZC-Customer Portal",
      productFamily: "Reveal",
      status: "New",
      esn: createCaseState.esn,
      vehicleLabel: createCaseState.vehicleLabel,
      region: constructCaseHyperLink(regionId)[0],
      language: constructCaseHyperLink(regionId)[1],
    };
    let response = yield createCaseCall(requestBody);

    if (response.data.data.id) {
      yield put(CreateCaseActions.setNewCase(response.data.data));
      yield put(GlobalActions.setCaseNumberGlobal(response.data.data.id));
      yield put(CreateCaseActions.setSubmitAttachment(true));
      pendoTrack("Customer Portal | Support Cases | Create New Case | Case Creation", {
        status: "Success",
        statusCode: response.data.statusCode,
        accountId: accountstate.accountNumber,
      });
    } else {
      yield put(Actions.setCaseCreatedSuccess(false));
      yield put(CreateCaseActions.setCreateCaseFieldsErr("newCaseErr", true));
      yield put(CreateCaseActions.setSubmitAttachment(false));
      yield put(CreateCaseActions.setCancelDisable(false));
      yield put(CreateCaseActions.setLoader(false));
      yield delay(5000);
      yield put(CreateCaseActions.setCreateCaseFieldsErr("newCaseErr", false));
      yield put(CreateCaseActions.setSubmitButton(false));
      pendoTrack("Customer Portal | Support Cases | Create New Case | Case Creation", {
        status: "Failed",
        statusCode: response.data.statusCode,
        accountId: accountstate.accountNumber,
      });
    }
  } catch (error) {
    console.log("get type error ->  ", error);
    yield put(Actions.setCaseCreatedSuccess(false));
    yield put(CreateCaseActions.setCreateCaseFieldsErr("newCaseErr", true));
    yield put(CreateCaseActions.setSubmitAttachment(false));
    yield put(CreateCaseActions.setCancelDisable(false));
    yield put(CreateCaseActions.setLoader(false));
    //Status code is not available for pendo
    yield delay(5000);
    yield put(CreateCaseActions.setCreateCaseFieldsErr("newCaseErr", false));
    yield put(CreateCaseActions.setSubmitButton(false));
    pendoTrack("Customer Portal | Support Cases | Create New Case | Case Creation", {
      status: "Failed",
      statusCode: error.response.data.statusCode,
      accountId: accountStateData.accountNumber,
    });
  }
}

function* getAllViewCaseDetails({ isLoading }) {
  try {
    let caseId = yield select((state) => state.VIEWCASEDETAILS.caseId);
    const accountstate = yield select((state) => state.ACCOUNT);
    if (!isLoading) {
      yield put(viewCaseDetailsActions.setLoader(true));
    }
    const response = yield getCaseDetailsCall({ caseId, regionId: accountstate.regionId });
    if (Object.keys(response.data.data).length !== 0) {
      let data = yield call(caseStatusMapping, [response.data.data]);
      yield put(viewCaseDetailsActions.setAllViewCaseDetails(...data));
    }
    yield put(viewCaseDetailsActions.setLoader(false));
  } catch (error) {
    yield put(viewCaseDetailsActions.setLoader(false));
    console.log("error", error);
  }
}

function* getActivity() {
  try {
    let caseId = yield select((state) => state.VIEWCASEDETAILS.caseId);
    const accountstate = yield select((state) => state.ACCOUNT);
    yield put(viewCaseDetailsActions.setActivityErr(false));
    const response = yield getActivityCall({ caseId, regionId: accountstate.regionId });

    if (Object.keys(response.data.data).length !== 0) {
      let data = yield call(caseStatusMapping, [response.data.data]);
      yield put(viewCaseDetailsActions.setActivity(...data));
    }
  } catch (error) {
    yield put(viewCaseDetailsActions.setActivityErr(true));
    console.log("error", error);
  }
}

function* closeCase() {
  try {
    let caseId = yield select((state) => state.VIEWCASEDETAILS.caseId),
      fullName = yield select((state) => state.ACCOUNT.fullName);
    yield put(viewCaseDetailsActions.setLoader(true));
    yield put(viewCaseDetailsActions.setCloseCaseError(false));
    yield put(viewCaseDetailsActions.setCloseCaseSuccess(false));
    let requestBody = { caseId, caseClosedByName: fullName };
    const response = yield closeCaseCall(requestBody);
    if (response.data.statusCode === "200") {
      yield put(viewCaseDetailsActions.setCloseCaseSuccess(true));
    } else {
      yield put(viewCaseDetailsActions.setLoader(false));
    }
  } catch (error) {
    yield put(viewCaseDetailsActions.setLoader(false));
    yield put(viewCaseDetailsActions.setCloseCaseError(true));
    console.log("error", error);
  }
}

function* addComment() {
  let accountData = yield select((state) => state.ACCOUNT);
  try {
    yield put(viewCaseDetailsActions.setCommentsSubmit(true));
    yield put(viewCaseDetailsActions.setDisableCommentCancel(true));
    yield put(viewCaseDetailsActions.setCommentsLoader(true));
    let caseDetail = yield select((state) => state.VIEWCASEDETAILS);
    let account = yield select((state) => state.ACCOUNT);
    let caseID = yield select((state) => state.VIEWCASEDETAILS);
    let fileDetail = caseDetail.commentAttachments;

    let requestBody = {
      caseId: caseID.caseId,
      emailBody: caseDetail.comments,
      toEmailAddress: caseDetail.toEmailAddress,
      fromAddress: account.emailAddress,
      subject: caseDetail.subject,
      threadId: caseDetail.threadId,
      attachments: fileDetail.length === 0 ? null : fileDetail,
    };

    let response = yield addCommentCall(requestBody);

    if (response.data.data.success === true) {
      yield put(viewCaseDetailsActions.setSubmitCommentAttachment(true));

      pendoTrack("Customer Portal | Support Cases | Add Comments | Comment Creation", {
        status: "Success",
        statusCode: response.data.statusCode,
        accountId: account.accountNumber,
      });
    } else {
      yield put(viewCaseDetailsActions.setCaseReplySuccess(false));
      yield put(viewCaseDetailsActions.addCommentAttachmentError(true, ""));
      yield put(viewCaseDetailsActions.setSubmitCommentAttachment(false));
      yield put(viewCaseDetailsActions.setDisableCommentCancel(false));
      yield put(viewCaseDetailsActions.setCommentsLoader(false));
      yield delay(4000);
      yield put(viewCaseDetailsActions.addCommentAttachmentError(false, ""));
      yield put(viewCaseDetailsActions.setCommentsSubmit(false));
      pendoTrack("Customer Portal | Support Cases | Add Comments | Comment Creation", {
        status: "Failed",
        statusCode: response.data.statusCode,
        accountId: account.accountNumber,
      });
    }
  } catch (error) {
    console.log("LOG DATA IN WHEN ADD COMMENT ERROR");
    yield put(viewCaseDetailsActions.setCaseReplySuccess(false));
    yield put(viewCaseDetailsActions.addCommentAttachmentError(true, ""));
    yield put(viewCaseDetailsActions.setSubmitCommentAttachment(false));
    yield put(viewCaseDetailsActions.setDisableCommentCancel(false));
    yield put(viewCaseDetailsActions.setCommentsLoader(false));
    yield delay(4000);
    yield put(viewCaseDetailsActions.addCommentAttachmentError(false, ""));
    yield put(viewCaseDetailsActions.setCommentsSubmit(false));
    pendoTrack("Customer Portal | Support Cases | Add Comments | Comment Creation", {
      status: "Failed",
      statusCode: error.response.data.statusCode,
      accountId: accountData.accountNumber,
    });
  }
}

export default function* casesWatcher() {
  yield all([
    takeLatest(GET_ALL_CASES, getAllCases),
    takeLatest(GET_CLOSED_CASES, getClosedCases),
    takeLatest(GET_TYPE_ARR, getTypeData),
    takeLatest(GET_SPECIFIC_TYPE_ARR, getSpecificTypeData),
    takeLatest(CREATE_NEW_CASE, createNewCase),
    takeLatest(GET_ALL_VIEW_CASE_DETAILS, getAllViewCaseDetails),
    takeLatest(GET_ACTIVITY, getActivity),
    takeLatest(CLOSE_CASE, closeCase),
    takeLatest(ADD_COMMENT, addComment),
  ]);
}
